import { render, staticRenderFns } from "./SnAnomalyReport.vue?vue&type=template&id=56b48094&scoped=true&"
import script from "./SnAnomalyReport.vue?vue&type=script&lang=js&"
export * from "./SnAnomalyReport.vue?vue&type=script&lang=js&"
import style0 from "./SnAnomalyReport.vue?vue&type=style&index=0&id=56b48094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b48094",
  null
  
)

export default component.exports